<template>
  <EntityForm model-constructor="MyProfile"
              api-url="/users/api/profile"
              v-model:entity="userProfile"
              :entity-id="props.userId"
              form-name="Profile"
              v-model:editState="isEditingProfile"
              v-bind:show-title=true>

    <div v-if="userProfile">
      <div class="row">
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label f-w-600" for="profile-first-name-input">First Name</label>
            <input
                id="profile-first-name-input"
                v-model="userProfile.state.firstName"
                class="form-control"
                type="text"
                placeholder="Johnny"
                :disabled="!isEditingProfile"
                :readonly="!isEditingProfile"/>
            <div id="profile-first-name-error" class="invalid-feedback d-none">Please enter the first
              name.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label f-w-600" for="profile-last-name-input">Last Name</label>
            <input
                id="profile-last-name-input"
                v-model="userProfile.state.lastName"
                class="form-control"
                type="text"
                placeholder="Smith"
                :disabled="!isEditingProfile"
                :readonly="!isEditingProfile"/>
            <div id="profile-last-name-error" class="invalid-feedback d-none">
              Please enter the last name.
            </div>
          </div>
        </div>
      </div>
    </div>
  </EntityForm>

  <div class="card">
    <div class="card-body">
      <h4 class="mb-3">
        Authentication
      </h4>
      <div v-if="userProfile.state" class="row">
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label f-w-600" for="profile-email-input">Email</label>
            <input
                id="profile-email-input"
                v-model="userProfile.state.email"
                class="form-control"
                type="text"
                autocomplete="username"
                placeholder="email@example.com"
                :disabled="true"
                :readonly="true"/>
            <div id="email-update-link">
              <a class="link" @click="toggleEmailUpdateModal()" href="#">Update my email</a>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label f-w-600" for="profile-password-input">Password</label>
            <input
                id="profile-password-input"
                class="form-control"
                type="password"
                value="********"
                autocomplete="current-password"
                :disabled="true"
                :readonly="true"/>
            <div id="password-update-link">
              <a class="link" @click="togglePasswordResetModal()" href="#">Update my password</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="password-reset-modal" tabindex="-1" role="dialog"
       aria-labelledby="rest-password-modal" aria-hidden="true">
    <div class="modal-dialog modal-fullscreen-sm-down">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title fs-5" id="exampleModalLongTitle">Reset Your Password</h3>
          <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="login-main">
            <form class="theme-form">
              <div class="form-group">
                <p v-if="passwordResetErrorMessage" class="text-danger">{{ passwordResetErrorMessage }}</p>

                <label class="col-form-label">Current Password</label>
                <div class="form-input position-relative">
                  <input class="form-control" type="password" name="login[password]"
                         id="current-password-input"
                         v-model="currentPassword"
                         autocomplete="current-password"
                         required placeholder="*********">
                  <div class="show-hide"><span class="show"></span></div>
                  <div id="current-password-input-error" class="invalid-feedback d-none">
                    Please enter your current password.
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-form-label">New Password</label>
                <div class="form-input position-relative">
                  <input class="form-control" type="password" name="login[password]"
                         id="new-password-input"
                         autocomplete="new-password"
                         v-model="newPassword"
                         placeholder="*********"
                         required>
                  <div class="show-hide"><span class="show"></span></div>
                  <div id="new-password-input-error" class="invalid-feedback d-none">
                    Please enter a new password.
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-form-label">Confirm Password</label>
                <div class="form-input position-relative">
                  <input class="form-control" type="password" name="login[password]"
                         id="confirm-password-input"
                         v-model="confirmPassword"
                         autocomplete="confirm-password"
                         required>
                  <div class="show-hide"><span class="show"></span></div>
                  <div id="confirm-password-input-error" class="invalid-feedback d-none">
                    Passwords do not match.
                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>

        <div class="modal-footer">
          <div>
            <button class="btn btn-primary btn-block w-100 " type="submit" @click="resetPassword()">Done</button>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="email-update-modal" tabindex="-1" role="dialog"
       aria-labelledby="update-email-modal" aria-hidden="true">
    <div class="modal-dialog modal-fullscreen-sm-down">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title fs-5" id="exampleModalLongTitle">Update Email</h3>
          <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="login-main">
            <form class="theme-form">

              <div class="form-group">
                <label class="col-form-label">Current Email:
                  <span v-if="userProfile.state">
                  {{ userProfile.state.email }}
                </span>
                </label>
              </div>


              <div class="form-group">
                <label class="col-form-label">New Email</label>
                <div class="form-input position-relative">
                  <input class="form-control" type="email" name="email-auth"
                         id="new-email-input"
                         v-model="newEmail"
                         :disabled="verificationSent"
                         :readonly="verificationSent"
                         placeholder="new@example.com"/>
                  <div id="new-email-input-error" class="invalid-feedback d-none">
                    Please enter a new and valid email address.
                  </div>
                </div>
              </div>


              <div v-if="verificationSent" class="form-group">

                <div class="text-muted mt-3">
                  <p>A verification code has been sent to your new email.
                  </p>
                  <p>
                    Click "Resend Verification" if you have not received a code in <b>30 seconds.</b>
                  </p>
                </div>
                <label class="col-form-label">Enter Verification Code</label>
                <div class="form-input position-relative">
                  <input class="form-control" type="text" name="email-auth" id="verification-code-input"
                         v-model="verificationCode"/>
                </div>
              </div>

            </form>
          </div>
        </div>

        <div class="modal-footer">
          <div v-if="!verificationSent">
            <button class="btn btn-primary btn-block w-100" type="submit" @click="sendEmailVerification()">Verify
              Email
            </button>
          </div>

          <div v-if="verificationSent">
            <button class="btn btn-primary btn-block w-100 me-3" type="submit" @click="updateEmail()">
              Confirm and Update
            </button>
            <button class="btn btn-outline-secondary btn-block w-100" type="submit" @click="sendEmailVerification()">
              Resend Verification
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import EntityForm from './EntityForm.vue';
import {nextTick, ref} from "vue";
import Swal from "../../extras/js/sweetalert/sweetalert2.min";
import _ from 'lodash';
import {showToast} from "../utility/toastNotificationUtility";

const props = defineProps({
  userId: {type: String, required: true},
});

const userProfile = ref({});
const isEditingProfile = ref(false);

//create functions for updating the email and password seperately

const newEmail = ref(null);
const verificationCode = ref(null);
const verificationSent = ref(false);

const currentPassword = ref(null);
const newPassword = ref(null);
const confirmPassword = ref(null);
const passwordResetErrorMessage = ref(null);
const passwordFormRefresher = ref(true);

const togglePasswordResetModal = function () {
  passwordFormRefresher.value = false;
  currentPassword.value = null;
  newPassword.value = null;
  confirmPassword.value = null;


  passwordResetErrorMessage.value = null;
  $('#password-reset-modal').modal('toggle');

  nextTick(() => {
    passwordFormRefresher.value = true;
  });
};

const validatePasswordResetForm = () => {
  let isValid = true;
  if (!_.isEmpty(currentPassword.value)) {
    $('#current-password-input').removeClass('is-invalid');
    $('#current-password-input-error').addClass('d-none');
  } else {
    $('#current-password-input').addClass('is-invalid');
    $('#current-password-input-error').removeClass('d-none');
    isValid = false;
  }

  if (!_.isEmpty(newPassword.value)) {
    $('#new-password-input').removeClass('is-invalid');
    $('#new-password-input-error').addClass('d-none');
  } else {
    $('#new-password-input').addClass('is-invalid');
    $('#new-password-input-error').removeClass('d-none');
    isValid = false;
  }

  if (!_.isEmpty(confirmPassword.value) &&
      _.isEqual(confirmPassword.value, newPassword.value)) {
    $('#confirm-password-input').removeClass('is-invalid');
    $('#confirm-password-input-error').addClass('d-none');
  } else {
    $('#confirm-password-input').addClass('is-invalid');
    $('#confirm-password-input-error').removeClass('d-none');
    isValid = false;
  }

  return isValid;
}

const resetPassword = async function () {
  const valid = validatePasswordResetForm();
  if (!valid)
    return false;

  passwordResetErrorMessage.value = null;

  //send request that confirms old password first and then sets new password
  const response = await fetch('/api/authenticate/update-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userName: userProfile.value.state.email,
      currentPassword: currentPassword.value,
      newPassword: newPassword.value
    }),
  });

  if (response.ok) {
    //toggle form modal
    $('#password-reset-modal').modal('toggle');

    //show success alert
    Swal.fire({
      title: "Password Updated Successfully!",
      icon: "success",
      confirmButtonText: "Ok"
    }).then((result) => {
      window.location.reload();
    });
  } else {
    passwordResetErrorMessage.value = await response.text();
  }
};

const toggleEmailUpdateModal = () => {
  verificationCode.value = null;
  verificationSent.value = false;
  newEmail.value = null;
  $('#email-update-modal').modal('toggle');
};

const validateEmailVerificationForm = () => {
  let isValid = true;
  if (!_.isEmpty(newEmail.value)) {
    $('#new-email-input').removeClass('is-invalid');
    $('#new-email-input-error').addClass('d-none');
  } else {
    $('#new-email-input').addClass('is-invalid');
    $('#new-email-input-error').removeClass('d-none');
    isValid = false;
  }

  return isValid;
}

const sendEmailVerification = async function () {
  const valid = validateEmailVerificationForm();
  if (!valid)
    return false;

  //send verification email
  const response = await fetch('/api/authenticate/send-email-verification', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      currentEmail: userProfile.value.state.email,
      newEmail: newEmail.value
    }),
  });

  if (response.ok) {
    //if resending, show toast
    if (verificationSent.value) {
      showToast({
        title: 'Verification Sent',
        body: `Verification has been sent to ${newEmail.value}!`,
        type: 'success',
        delay: 7000
      });
    }

    verificationSent.value = true;
  } else {
    showToast({
      title: 'Error',
      body: await response.text(),
      type: 'error',
      delay: 7000
    });
  }
}

const updateEmail = async function () {
  const response = await fetch('/api/authenticate/update-email ', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      currentEmail: userProfile.value.state.email,
      verificationCode: verificationCode.value,
      newEmail: newEmail.value
    }),
  });
  if (response.ok) {
    //toggle form modal
    $('#email-update-modal').modal('toggle');

    //show success alert
    Swal.fire({
      title: "Email Updated Successfully!",
      icon: "success",
      confirmButtonText: "Ok"
    }).then((result) => {
      window.location.reload();
    });

  } else {
    showToast({
      title: 'Error',
      body: await response.text(),
      type: 'error',
      delay: 7000
    });
  }
}
</script>
